import { Pipe, PipeTransform } from '@angular/core';
import { replaceAll } from '../../util';

@Pipe({
    name: 'urlClean',
    standalone: true
})
export class UrlCleanPipe implements PipeTransform {
	transform(text: string): any {
		try {
			text = decodeURIComponent(text);
		}catch(err){
            // empty catch intentionally. It's impossible to log in a directive
		}
		text = replaceAll(text, '%', '-');
		text = replaceAll(text, ' ', '-');
		try {
			text = encodeURIComponent(text);
		}catch(err){
            // empty catch intentionally. It's impossible to log in a directive
		}
		return text;
	}
}
